/**
 * A body of all SemanticText (sentences or paragraphs)
 */
import { defaultText, enableSocket } from '../constants'
import { joinTextArray } from '../scripts/text'
import { socket } from '../socket'
import BaselineText from './BaselineText'
import Instruction from './Instruction'
import SemanticText from './SemanticText'
import { _hub_exp_expId, _hub_exp_thisTask } from './hub'
import { blue } from '@material-ui/core/colors'
import PropTypes from 'prop-types'
import React, { createRef, Component } from 'react'

let touchmoveFunction = null
let touchendFunction = null

export default class SemanticBody extends Component {
  constructor(props) {
    super(props)

    // this.state = {
    //   text: example.text,
    // }
    this.state = {
      targetInstruction: '',
      text: '',
      mode: 'word',
      refreshed: 0,
    }

    this.ref = createRef()

    this.onTouchmove = this._touchmoveListener.bind(this)
    this.onTouchend = this._touchendListener.bind(this)
    this.handleChangeTextFunction = this.handleChangeText.bind(this)
  }

  componentDidMount() {
    document.addEventListener('touchmove', this.onTouchmove, {
      passive: false,
      cancelable: true,
    })
    document.addEventListener('touchend', this.onTouchend)

    window.scrollTo(0, 1)

    // Socket
    if (!defaultText && enableSocket) {
      socket.on('newTrial', data => {
        console.log('[newTrial] Received new task!')

        const {
          experimenterId,
          mode, // baseline or touch
          task: { taskType, taskId, text, targetText, targetInstruction },
        } = data
        _hub_exp_expId.current = experimenterId

        _hub_exp_thisTask.mode = mode
        _hub_exp_thisTask.taskType = taskType
        _hub_exp_thisTask.taskId = taskId
        _hub_exp_thisTask.originalText = text
        _hub_exp_thisTask.text = text
        _hub_exp_thisTask.targetText = targetText

        this.setState({
          targetInstruction: targetInstruction,
          text: text,
          mode: mode,
        })
      })

      socket.on('refreshTrial', data => {
        console.log('Trial refreshed!')
        console.log(data)
        this.setState({
          refreshed: this.state.refreshed + 1,
        })
      })
    }
  }

  componentWillUnmount() {
    document.removeEventListener('touchmove', this.onTouchmove)
    document.removeEventListener('touchend', this.onTouchend)

    // Socket
    if (enableSocket) socket.off('newTrial')
  }

  handleChangeText(textArray) {
    let t
    if (typeof textArray === 'string') {
      t = textArray
    } else {
      t = joinTextArray(textArray)
    }
    _hub_exp_thisTask.text = t // !
    this.setState({ text: t })
  }

  /* --------------------------------- Events --------------------------------- */

  _touchmoveListener(e) {
    if (touchmoveFunction) touchmoveFunction(e)
  }

  _touchendListener(e) {
    // _hub_restore_touchPoints()
    if (touchendFunction) touchendFunction(e)
    touchmoveFunction = null
    touchendFunction = null
  }

  attachTouchmoveFunction(f) {
    touchmoveFunction = f
  }

  attachTouchendFunction(f) {
    touchendFunction = f
  }

  /* -------------------------------------------------------------------------- */

  render() {
    const { text, targetInstruction, mode, refreshed } = this.state

    const t =
      defaultText || text ? (
        <>
          {targetInstruction.length !== 0 && !defaultText && (
            <Instruction text={`${targetInstruction}`} />
          )}
          {!mode.includes('baseline') ? (
            <SemanticText
              key={`${mode}:${text}`}
              text={defaultText || text}
              instruction={targetInstruction}
              attachTouchmoveFunction={this.attachTouchmoveFunction}
              attachTouchendFunction={this.attachTouchendFunction}
              bodyChangeText={this.handleChangeTextFunction}
              mode={mode}
              refreshed={refreshed}
            />
          ) : (
            <BaselineText
              key={`baseline:${text}`}
              text={text}
              instruction={targetInstruction}
              attachTouchmoveFunction={this.attachTouchmoveFunction}
              attachTouchendFunction={this.attachTouchendFunction}
              bodyChangeText={this.handleChangeTextFunction}
            />
          )}
        </>
      ) : (
        <Instruction text={''} />
      )

    const isTraining =
      _hub_exp_thisTask.taskId && _hub_exp_thisTask.taskId.includes('training')

    return (
      <>
        {/* <p className={`task-id-marker`}>
          {(isTraining ? 'TRAINING ' : '') +
            (_hub_exp_thisTask.taskId ? _hub_exp_thisTask.taskId : '')}
        </p> */}
        <h1
          className="demo-title"
          style={{
            color: blue[600],
          }}
        >
          1D-Touch Demo
        </h1>
        <button
          className="mode-switching-button"
          onClick={() => {
            this.setState({
              mode: this.state.mode === 'word' ? 'touch' : 'word',
            })
          }}
        >
          You are using{' '}
          <span className="button-em">
            {this.state.mode === 'word' ? 'WordTouch' : 'ChunkTouch'}
          </span>
          .
          <br />
          <span
            style={{
              fontSize: '0.75em',
              color: 'gray',
            }}
          >
            Click to Switch to{' '}
            {this.state.mode === 'word' ? 'ChunkTouch' : 'WordTouch'}.
          </span>
        </button>
        <div ref={this.ref} id="text-area" className="text-area">
          {t}
        </div>
      </>
    )
  }
}

SemanticBody.propTypes = {
  text: PropTypes.string,
}
